import apiReward from '@/api/vo/reward';

const defaultState = () => ({
	listReward: [],
	rewardPagination: '',
	listRewardCanClaim: [],
	rewardCanClaimPagination: '',
	listRewardClaimed: [],
	rewardClaimedPagination: '',
	pointMember: {},

	responSuccess: {},
	responseError: {},
});

const state = defaultState();

const getters = {

};

const mutations = {

	setReward(state, data) {
		state.listReward = data.data;
		state.rewardPagination = data.pagination;
	},
	setRewardCanClaim(state, data) {
		state.listRewardCanClaim = data.data;
		state.rewardCanClaimPagination = data.pagination;
	},
	setRewardClaimed(state, data) {
		state.listRewardClaimed = data.data;
		state.rewardClaimedPagination = data.pagination;
	},
	setPointMember(state, data) {
		state.pointMember = data.data;
	},

	saveResponseError(state, data) {
		state.responseError = data;
	},
	saveResponse(state, data) {
		state.responSuccess = data
		state.responseError = ''
	},
};

const actions = {

	getReward({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getReward(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setReward', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, data reward tidak dapat ditampilkan.'
				}, { root: true });
				reject()
			});
		});
	},
	getRewardCanClaim({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardCanClaim(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setRewardCanClaim', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, data reward tidak dapat ditampilkan.'
				}, { root: true });
				reject()
			});
		});
	},
	getRewardClaimed({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardClaimed(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setRewardClaimed', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, data reward tidak dapat ditampilkan.'
				}, { root: true });
				reject()
			});
		});
	},
	getPointMember({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getPointMember(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setPointMember', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, point tidak dapat ditampilkan.'
				}, { root: true });
				reject()
			});
		});
	},
	claimReward({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.claimReward(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('saveResponse', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, klaim reward tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},
	claimRewardCash({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.claimRewardCash(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('saveResponse', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, klaim reward tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};